module.exports = __webpack_public_path__ + "img/img_accredit_face.5c3da734.svg";